// extracted by mini-css-extract-plugin
module.exports = {"footerLink":"FooterLink_footerLink__1sj6A","icon":"FooterLink_icon__3ph8M","leftContent":"FooterLink_leftContent__3-gZm"};